import React, { useEffect, useState } from 'react';
import Script from 'next/script';
import NextHead from '@/components/NextHead';
import styled from 'styled-components';
import metas from '@/routes/meta';
import Page from 'components/Page';

const LanguageDropDown = styled.div`
  padding: 0 1rem;
  select {
    padding: 8px 10px;
    border-radius: 4px;
  }
`;

const Notice = styled.div`
  ul {
    list-style: none;
    padding: 0;
  }
  li {
    padding-bottom: 8px;
  }
  a {
    color: #c0ad86;
    font-family: 'Source Sans Pro', sans-serif;
    text-underline-position: under;
    font-weight: 600;
    font-size: 1.1em;
  }
`;

export default function AccessibilityStatement() {
  const [dataSettings, setDataSettings] = useState('');

  useEffect(() => {
    let mounted = true;
    const interval = setInterval(() => {
      const initialized = window?.OneTrust?.NoticeApi?.Initialized;

      if (initialized) {
        clearInterval(interval);

        initialized.then(() => {
          if (!mounted) return;

          window.OneTrust?.NoticeApi?.LoadNotices(
            [
              'https://privacyportalde-cdn.onetrust.com/24527c35-1de1-4aaa-833d-de50b42446bd/privacy-notices/56554c5c-7c6d-4fdb-be79-8b3421f7aec7.json',
            ],
            true,
            'en-us',
          );
        });
      }
    }, 200);

    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.btoa) {
      setDataSettings(
        window.btoa(
          '{"callbackUrl":"https://privacyportal-de.onetrust.com/request/v1/privacyNotices/stats/views"}',
        ),
      );
    }
  }, []);

  return (
    <Page title="Accessibility Statement">
      {dataSettings && (
        <Script
          id="otprivacy-notice-script"
          src="https://privacyportalde-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js"
          type="text/javascript"
          data-settings={dataSettings}
        />
      )}
      <NextHead meta={metas.default} />
      <LanguageDropDown className="otnotice-language-dropdown-container">
        <select
          id="otnotice-language-dropdown"
          aria-label="language selector"
        />
      </LanguageDropDown>

      <Notice
        id="otnotice-56554c5c-7c6d-4fdb-be79-8b3421f7aec7"
        className="otnotice"
      />
    </Page>
  );
}
